var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKyc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55 6.667L58.333 10l3.334-3.333-3.334-3.334L55 6.667zM34.166 75.833l2.5 2.5 2.5-2.5-2.5-2.5-2.5 2.5zm-22.5-3.333h2.5V70h-2.5v2.5z",
    fill: "#76808F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 15h70v24.167h5V42.5H0v-3.333h5V15zm6.666 24.167h20V25.833h-20v13.334z",
    fill: "#76808F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M5 40.833h70V65H5V40.833zm6.666-15h20v13.334h-20V25.833z",
    fill: "#76808F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 45.833v10h20v-10h-5.833L21.665 50 17.5 45.833h-5.833z",
    fill: "url(#paint0_linear_1288_31969)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 25.833h15.833v3.334H37.5v-3.334z",
    fill: "url(#paint1_linear_1288_31969)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 35.833h30.833v3.334H37.5v-3.334z",
    fill: "url(#paint2_linear_1288_31969)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#76808F",
    d: "M37.5 45.833h30.833v3.333H37.5zm0 6.667h30.833v3.333H37.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.937 39.167a5.834 5.834 0 10-10.544 0h10.544z",
    fill: "url(#paint3_linear_1288_31969)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.735 42.5h-.14a5.414 5.414 0 00.14 0z",
    fill: "url(#paint4_linear_1288_31969)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1288_31969",
    x1: 21.666,
    y1: 45.833,
    x2: 21.666,
    y2: 55.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76808F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1288_31969",
    x1: 37.5,
    y1: 32.5,
    x2: 68.333,
    y2: 32.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1288_31969",
    x1: 37.5,
    y1: 32.5,
    x2: 68.333,
    y2: 32.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1288_31969",
    x1: 21.665,
    y1: 30.834,
    x2: 21.665,
    y2: 42.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1288_31969",
    x1: 21.665,
    y1: 30.834,
    x2: 21.665,
    y2: 42.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyc);
export default __webpack_public_path__ + "static/media/kyc.4738ef2d0f7fb9dfae46b2ddb1a88dd7.svg";
export { ForwardRef as ReactComponent };